import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "form-control w-full" }
const _hoisted_2 = { class: "label pb-3 pt-1" }
const _hoisted_3 = ["data-tip"]
const _hoisted_4 = { class: "w-full flex flex-wrap justify-start items-center gap-1" }
const _hoisted_5 = ["onMouseover"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "absolute left-0 pt-1 z-10" }
const _hoisted_8 = ["onClick"]

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListSwitcher',
  props: {
    entries: {},
    current: {},
    title: {},
    noInsert: { type: Boolean },
    noDelete: { type: Boolean },
    isHighlighted: { type: Function },
    tooltip: {}
  },
  emits: ["select", "insert", "delete"],
  setup(__props: any) {





const hoverEntry = ref<number | null>(null);
const buttons = ref<HTMLElement[]>([]);

// const mouseOut = () => {
//   setTimeout(() => {
//     hoverEntry.value = null;
//   }, 200);
// };

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("label", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass(["label-text pl-2", _ctx.tooltip ? 'tooltip' : '']),
          "data-tip": _ctx.tooltip ?? ''
        }, _toDisplayString(_ctx.title ?? "List"), 11, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_TransitionGroup, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry, id) => {
            return (_openBlock(), _createElementBlock("div", {
              ref_for: true,
              ref_key: "buttons",
              ref: buttons,
              key: id,
              onMouseover: ($event: any) => (hoverEntry.value = id),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoverEntry.value = null)),
              class: "relative inline-block"
            }, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.$emit('select', id)),
                type: "button",
                class: _normalizeClass([
              'btn btn-neutral btn-circle btn-sm h-9 w-9 no-animation',
              id == _ctx.current
                ? ''
                : 'btn-outline text-neutral hover:border-neutral hover:bg-neutral',
              'transition-[filter] transition-transform ease-in-out duration-500',
              _ctx.isHighlighted && _ctx.isHighlighted(id) ? 'invert scale-125' : '',
            ])
              }, _toDisplayString(entry), 11, _hoisted_6),
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "btn btn-circle btn-sm btn-outline h-9 w-9 text-neutral bg-base-100 hover:border-neutral hover:bg-neutral",
                  onClick: ($event: any) => (_ctx.$emit('delete', id))
                }, [
                  _createVNode(_component_Icon, {
                    icon: "ic:baseline-delete",
                    onMouseout: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  })
                ], 8, _hoisted_8)
              ], 512), [
                [_vShow, hoverEntry.value == id && !_ctx.noDelete]
              ])
            ], 40, _hoisted_5))
          }), 128)),
          _withDirectives(_createElementVNode("button", {
            key: "__add_button__",
            class: "btn btn-circle btn-sm btn-outline h-9 w-9 text-neutral hover:border-neutral hover:bg-neutral",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('insert', _ctx.entries.length)))
          }, [
            _createVNode(_component_Icon, {
              icon: "ic:baseline-add",
              class: "hover:fill-neutral-content"
            })
          ], 512), [
            [_vShow, !_ctx.noInsert]
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})